import { isServerSide } from 'helpers/isServerSide';
import { getScreen } from 'helpers/window';

export const addScreenHeadersInterceptor = (config, restClientInstance) => {
	if (config.trackScreenSize && !isServerSide()) {
		restClientInstance._axios.interceptors.request.use((config) => {
			try {
				const screen = getScreen();
				if (screen) {
					config.headers['screen-width'] = screen.width;
					config.headers['screen-height'] = screen.height;
				}
			} catch (error) {}
			return config;
		});
	}
};
